export enum PollType {
  Survey = 1,
  Voting = 2,
}

export enum PollStatus {
  New = 1,
  Active = 2,
  Completed = 3,
}

export enum PollQuestionType {
  oneAnswer = 1,
  manyAnswers = 2,
}
